import { render, staticRenderFns } from "./AutomacaoWizard.vue?vue&type=template&id=556778ba"
import script from "./AutomacaoWizard.vue?vue&type=script&lang=js"
export * from "./AutomacaoWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports